class RemoveConfirmationModal extends ModalDialog {
    constructor() {
        super();
        this.originalRemoveButton = null;
        this.removeButton = this.querySelector('[data-remove-confirm]');
        this.removeButton?.addEventListener('click',()=>{
            this.originalRemoveButton && this.originalRemoveButton.click();
            this.hide();
        });
    }

    show(opener) {
        super.show(opener);
        this.originalRemoveButton = document.querySelector(`#sidebar-cart [data-quantity="0"][data-line="${opener.dataset.line}"]`);
    }
}

customElements.define('remove-confirmation-modal', RemoveConfirmationModal);